import * as React from 'react';
import { Link, FieldProps, useRecordContext, ReferenceManyCount } from 'react-admin';
import { Topics } from '../../custom';

const ContentsLinkField = (props: FieldProps<Topics>) => {
    const record = useRecordContext();
    if (!record) {
        return null;
    }
    return (
        <Link
            to={`/programs/${record.programId}/subjects/${record.subjectId}/chapters/${record.chapterId}/topics/${record.id}/contents`}
        >
            Contents
        </Link>
    );
};

ContentsLinkField.defaultProps = {
    label: 'Contents',
};

export default ContentsLinkField;
